import type { ReactNode } from 'react';

interface SortThProps {
  col: string;
  sortCol: string;
  sortDir: 'asc' | 'desc';
  onSort: (col: string) => void;
  children: ReactNode;
  className?: string;
  tooltip?: string;
}

export function SortTh({ col, sortCol, sortDir, onSort, children, className, tooltip }: SortThProps) {
  return (
    <th
      className={['sortable', sortCol === col ? 'sorted' : '', className].filter(Boolean).join(' ')}
      onClick={() => onSort(col)}
      title={tooltip}
    >
      <span className="th-inner">
        {children}
        <span className="sort-icon">{sortCol === col ? (sortDir === 'asc' ? '↑' : '↓') : '↑'}</span>
      </span>
    </th>
  );
}
